<template>
    <div class="summary" v-if="summary">
        <div class="timeframe">
            <div class="item">
                <div class="header">{{ $t('sales.sidebar.all-day') }}</div>
                <div class="content">
                    <div class="column">
                        <div class="label">{{ $t('sales.table.header.forecast') }}</div>
                        <div class="value">{{ summaryFormatted.forecast_total }}</div>
                    </div>
                    <div class="column actual">
                        <div class="label">{{ $t('sales.table.header.actual') }}</div>
                        <div class="value">{{ summaryFormatted.actual_total }}</div>
                    </div>
                </div>
                <div class="bottombar">
                    <div class="item-row">
                        <div class="label">{{ $t('sales.table.header.difference') }}</div>
                        <div class="value" :class="{ 'positive': summaryFormatted.difference > 0, 'negative': summaryFormatted.difference < 0, 'neutral': summaryFormatted.difference == 0 }">{{ summaryFormatted.difference }}</div>
                    </div>
                    <div class="item-row">
                        <div class="label">{{ $t('sales.table.header.difference_percentage') }}</div>
                        <div class="value diff" :class="{ 'positive': summaryFormatted.difference_percentage > 0, 'negative': summaryFormatted.difference_percentage < 0, 'neutral': summaryFormatted.difference_percentage == 0 }">{{ Math.round(summaryFormatted.difference_percentage) }}%</div>
                    </div>
                    <div class="item-row" v-if="summaryFormatted.update_date">
                        <div class="label">{{ $t('sales.sidebar.update_date') }}</div>
                        <div class="value">{{ summaryFormatted.update_date }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatCurrency } from "@/utils/formatters";

export default {
    name: 'Timeframes',
    props: {
        summary: {
            type: Object,
            default: null
        }
    },
    computed: {
        summaryFormatted() {
            return {
                forecast_total: formatCurrency(this.summary.forecast_total),
                actual_total: formatCurrency(this.summary.aggregated_actual),
                difference: formatCurrency(this.summary.difference),
                difference_percentage: this.summary.difference_percentage,
                update_date: this.summary.last_update ? moment(this.summary.last_update).format('DD/MM/YYYY HH:mm') : null
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.summary {
    width: 100%;
    height: 100%;
    bottom: 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: space-between;

    .timeframe {
        width: 100%;
        border-radius: 4px;
        border: 1px solid $neutro;

        .item {
            width: 100%;
            .header {
                @include font-size(s);
                font-family: $text-bold;
                background-color: $default-sec-color;
                padding: 0 8px;
                text-transform: uppercase;
                width: 100%;
                height: 40px;
                display: flex;    

            }
            .content {
                padding: 8px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                .column {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 4px;
                    width: 100%;
                    &.actual {
                        background-color: $neutro-t80;
                        border: 1px solid $neutro;
                        border-radius: 4px;
                    }
                    
                    .label {
                        @include font-size(s);
                        word-break: break-word;
                        text-align: center;
                    }
                    .value {
                        font-family: $text-bold;
                        @include font-size(m);
                    }
                }
            }
            .bottombar {
                border-top: 1px solid $neutro;
                background-color: $neutro-t80;
                padding: 8px;

                .item-row {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    .label {
                        @include font-size(xs);
                    }
                    .value {
                        @include font-size(xs);

                        &.diff{
                            font-family: $text-bold;
                            padding: 0px 8px;
                            border-radius: 4px;
                            color: $color-white;
                            @include font-size(xs);

                            &.positive {
                                background-color: $done;
                            }
                            &.negative {
                                background-color: $error;
                            }
                            &.neutral {
                                background-color: $neutro;
                            }
                        }
                    }

                }
            }
            
        }
        
    }
}
</style>

